<script>
  import Stack from "../../components/layout/Stack.svelte";
  import Breadcrumbs from "../parts/Breadcrumbs.svelte";
  import SectionTitle from "../../components/layout/SectionTitle.svelte";
  import Section from "../../components/layout/Section.svelte";
  import { getAutoMpsProjectContext } from "../AutoMpsProjectContext.js";
  import FetchImportsByDataType from "./FetchImportsByDataType.svelte";
  import ImportsTable from "../parts/ImportsTable.svelte";
  import { constructImportsTableHeaders } from "../parts/ImportsTableUtils.js";
  import { localizeTableData } from "../plans/new/importStep/parts/tableUtils.js";

  export let dataType

  const ctx = getAutoMpsProjectContext()

  $: breadcrumbItems = [
    {
      title: "インポート一覧",
      href: `/auto-mps/projects/${$ctx.projectId}/imports`
    },
    {
      title: dataType,
      active: true,
    }
  ]
</script>

<div class="content-root">
  <Stack direction="vertical" gap="1rem">
    <Breadcrumbs
      items={breadcrumbItems}
    />
    <Section>
      <Stack direction="vertical">
        <SectionTitle>{dataType} のインポート一覧</SectionTitle>
        <FetchImportsByDataType projectId={$ctx.projectId} dataType={dataType} let:imports>
          <ImportsTable
            dataType={dataType}
            headers={constructImportsTableHeaders({insertViewImportButton: true})}
            rows={localizeTableData(imports)}
          />
        </FetchImportsByDataType>
      </Stack>
    </Section>
  </Stack>
</div>

<style>
  .content-root {
    width: 100%;
    height: 100%;
    padding: 1rem;
  }
</style>
